import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var StoreSlash = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 640 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68V252.6c-4 1-8 1.8-12.3 2.3h-.1c-5.3.7-10.7 1.1-16.2 1.1-12.4 0-24.3-1.9-35.4-5.3v100.2L301.2 210.7c7-4.4 13.3-9.7 18.8-15.7 15.9 17.6 39.1 29 65.2 29 26.2 0 49.3-11.4 65.2-29 16 17.6 39.1 29 65.2 29 4.1 0 8.1-.3 12.1-.8 55.5-7.4 81.8-72.5 52.1-119.4l-57.5-90.7C517.2 5 508.1 0 498.4 0H141.6c-9.7 0-18.8 5-23.9 13.1L95 49.1l-56.2-44zm73.4 218.1c4 .5 8.1.8 12.1.8 11 0 21.4-2 31-5.6L48.9 134.5c-6.1 40.6 19.5 82.8 63.3 88.7zM160 384V250.6c-11.2 3.5-23.2 5.4-35.6 5.4-5.5 0-11-.4-16.3-1.1h-.1c-4.1-.6-8.1-1.3-12-2.3V448c0 35.3 28.7 64 64 64h320c12.9 0 24.8-3.8 34.9-10.3L365.5 384H160z"
  }));
});
StoreSlash.displayName = 'StoreSlash';
export var StoreSlashDimensions = {
  height: 512,
  width: 640
};